export const LogoMark = ({ size = 32, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" className={className} aria-hidden="true">
    <path d="M6 25V8l10 11" fill="none" stroke="#3B82F6" strokeWidth="3.6" strokeLinecap="square" />
    <path d="M16 19l10-11v17" fill="none" stroke="#F59E0B" strokeWidth="3.6" strokeLinecap="square" />
    <circle cx="16" cy="19" r="2.6" fill="#F8FAFC" />
  </svg>
);

export const Logo = () => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark size={28} />
    <span className="font-display text-xl font-semibold tracking-tight">
      MidHq<span className="text-[var(--gold)]">.</span>
    </span>
  </span>
);
